<template>
  <div @click="openBus(busId)">
    <i class="fa fa-edit mr-2"></i>Reabrir Bus
  </div>
</template>

<script>
export default {
  props: ["busId"],
  methods: {
    async openBus(id) {


      try {
        this.$store.dispatch("buses/openBus", id);
      } catch (ex) {
        this.error = "Failed to load data";
      } finally {
        this.$notify({
          group: "foo",
          title: "Bus reabierto",
          text: "Se reabierto el bus seleccionado",
          type: "info"
        });
      }
    }
  }
};
</script>